export enum OptionType {
  AboveComponentTransom = 'above-component-transom',
  Additional = 'additional',
  AdditionalFees = 'additional-fees',
  AdditionalGroup = 'additional-group',
  AdditionalInformation = 'additional-information',
  AnchorPackage = 'anchor-package',
  Base = 'base',
  Brace = 'brace',
  BuildOnSitePrice = 'build-on-site-price',
  BuildingLayout = 'building-layout',
  Callout = 'callout',
  Ceiling = 'ceiling',
  Color = 'color',
  ColorGroup = 'color-group',
  ColorSubgroup = 'color-subgroup',
  Component = 'component',
  ComponentFamily = 'component-family',
  ComponentSelectablePackage = 'component-selectable-package',
  ComponentSelectablePackageItem = 'component-selectable-package-item',
  CornerStyle = 'corner-style',
  Cupola = 'cupola',
  CupolaAdditional = 'cupola-additional',
  CupolaFinishing = 'cupola-finishing',
  CupolaRoofing = 'cupola-roofing',
  CupolaSiding = 'cupola-siding',
  CustomInvoiceSections = 'custom-invoice-sections',
  Dealer = 'dealer',
  DeliveryLocation = 'delivery-location',
  DeliveryByZip = 'delivery-by-zip',
  Depth = 'depth',
  DoorHandle = 'door-handle',
  DoorHandleLocations = 'door-handle-locations',
  DoorSwing = 'door-swing',
  Dormer = 'dormer',
  DormerRoofSurface = 'dormer-roof-surface',
  Eave = 'eave',
  EngineerCertified = 'engineer-certified',
  ExtraFee = 'extra-fee', // not an actual option but required for connectionFees pricing adjustments
  Flooring = 'flooring',
  FlooringAttributes = 'flooring-attributes', // to ease the transition to flooring attributes
  FloorJoist = 'floorJoist',
  FlowerBox = 'flower-box',
  FrameSpacing = 'frame-spacing',
  FoundationBlock = 'foundation-block',
  /*
    FIXME: GableSiding OptionType shouldn't be necessary anymore now that we have wall specific siding
    Though we need a plan to migrate optionConditions that are refeering to 'gable-siding' options
  */
  GableSiding = 'gable-siding',
  GapPanel = 'gap-panel',
  Gauge = 'gauge',
  Height = 'height',
  Hinge = 'hinge',
  HingeLocations = 'hinge-locations',
  Installation = 'installation',
  InstallationSurface = 'installation-surface',
  Insulation = 'insulation',
  InsulationMaterial = 'insulation-material',
  InteriorRoof = 'interior-roof',
  InteriorWall = 'interior-wall',
  JTrim = 'j-trim',
  Layout = 'layout',
  LeanType = 'lean-type',
  Leg = 'leg',
  LegFootprint = 'leg-footprint',
  Length = 'length',
  LengthCombination = 'length-combination',
  LoafingShedSection = 'loafing-shed-section',
  Loft = 'loft',
  OverrideSidingForWall = 'override-siding-for-wall',
  OrderCalculation = 'order-calculation',
  Package = 'package',
  PaymentMethod = 'payment-method',
  PlacementType = 'placement-type',
  Porch = 'porch',
  PorchColumn = 'porch-column',
  PorchColumnHeight = 'porch-column-height',
  PorchColumnLayout = 'porch-column-layout',
  PorchDepth = 'porch-depth',
  PorchLength = 'porch-length',
  PorchRailing = 'porch-railing',
  PorchRailingFootprint = 'porch-railing-footprint',
  PorchSidewallDepth = 'porch-sidewall-depth',
  PostSpacing = 'post-spacing',
  Position = 'position',
  RainGutter = 'rain-gutter',
  Ramp = 'ramp',
  RentToOwn = 'rent-to-own',
  RoofCap = 'roof-cap',
  Roofing = 'roofing',
  RoofHatChannels = 'roof-hat-channels',
  RoofOverhang = 'roof-overhang',
  RoofPitch = 'roof-pitch',
  RoofPitchGroup = 'roof-pitch-group',
  RoofSheeting = 'roof-sheeting',
  RoofStructure = 'roof-structure',
  RoofSnoop = 'roof-snoop',
  RoofExtension = 'roof-extension',
  SceneryElement = 'scenery-element',
  Section = 'section',
  SectionSide = 'section-side',
  Shelves = 'shelves',
  Shutters = 'shutters',
  Siding = 'siding',
  SidingGroup = 'siding-group',
  SidingTransition = 'siding-transition',
  Size = 'size',
  Skylight = 'skylight',
  SnowLoad = 'snow-load',
  ComponentPackage = 'component-package',
  StaticComponent = 'static-component',
  StaticTrim = 'static-trim',
  Storage = 'storage',
  Style = 'style',
  StyleAttribute = 'style-attribute',
  StyleGroup = 'style-group',
  StyleVariation = 'style-variation',
  SubmitDialog = 'submit-dialog',
  SubmitDialogField = 'submit-dialog-field',
  SubmitDialogProperty = 'submit-dialog-property',
  SystemOrderCalculation = 'system-order-calculation',
  TabOrder = 'tab-order',
  Threshold = 'threshold',
  Transom = 'transom',
  Trim = 'trim',
  TrimPackage = 'trim-package',
  Trusses = 'trusses',
  Tutorial = 'tutorial',
  TutorialLink = 'tutorial-link',
  VisualInteriors = 'visual-interiors',
  Wainscot = 'wainscot',
  Wall = 'wall',
  WallFootprint = 'wall-footprint',
  WallFrame = 'wall-frame',
  WallInteriorSurface = 'wall-interior-surface',
  WallPosition = 'wall-position',
  WallSet = 'wall-set',
  WallStyle = 'wall-style',
  WallSide = 'wall-side', // FIXME: Rename WallSide to WallOrigin, makes more sense (Reiter)
  WallSurface = 'wall-surface',
  Weathervane = 'weathervane',
  Width = 'width',
  WindowHeaderHeight = 'window-header-height',
  WindBracing = 'wind-bracing',
  WorkBenches = 'workbenches',
  WallItems = 'wall-items',
  WraparoundCorner = 'wraparound-corner',
}
